import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { db } from '@siaedts/shared/lib/supabase';

const footerLinks = {
  company: [
    { key: 'aboutUs', href: '/about' },
    { key: 'ourTeam', href: '/about#team' },
    { key: 'partners', href: '/about#partners' },
    { key: 'careers', href: '/contact' },
  ],
  products: [
    { key: 'allProducts', href: '/products' },
    { key: 'categories', href: '/products#categories' },
    { key: 'featured', href: '/products?featured=true' },
    { key: 'inquiry', href: '/contact' },
  ],
  services: [
    { key: 'equipmentSales', href: '/products' },
    { key: 'partsAccessories', href: '/parts' },
    { key: 'expertService', href: '/service' },
    { key: 'precisionAg', href: '/precision-ag' },
    { key: 'irrigation', href: '/irrigation' },
    { key: 'financing', href: '/financing' },
  ],
  resources: [
    { key: 'news', href: '/news' },
    { key: 'gallery', href: '/gallery' },
    { key: 'faq', href: '/contact#faq' },
    { key: 'contact', href: '/contact' },
  ],
  legal: [
    { key: 'privacy', href: '/privacy' },
    { key: 'terms', href: '/terms' },
    { key: 'cookies', href: '/cookies' },
  ],
};

const socialLinks = [
  { name: 'Facebook', href: 'https://facebook.com', icon: (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
    </svg>
  )},
  { name: 'Twitter', href: 'https://twitter.com', icon: (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
    </svg>
  )},
  { name: 'LinkedIn', href: 'https://linkedin.com', icon: (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" />
    </svg>
  )},
  { name: 'Instagram', href: 'https://instagram.com', icon: (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.512.013-2.855.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 017.445 1.535c.636-.247 1.363-.416 2.427-.465C10.92 1.013 11.263 1 12.315 1h.08c2.513 0 2.855.013 3.808.06 1.023.047 1.379.218 2.427.465a4.902 4.902 0 011.772 1.153c.39.39.56.94.56 1.555v.08zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.808a3.327 3.327 0 100 6.654 3.327 3.327 0 000-6.654zm5.338-3.283a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
    </svg>
  )},
];

export function Footer() {
  const { t } = useTranslation();
  const [footerSettings, setFooterSettings] = useState<{ whatsapp_number?: string; social_links?: Record<string, string> }>({});
  useEffect(() => { void db.about.get().then((content) => { if (content) setFooterSettings(content); }).catch(() => undefined); }, []);
  const configuredSocialLinks = socialLinks.map((social) => ({ ...social, href: footerSettings.social_links?.[social.name.toLowerCase()] || '' })).filter((social) => social.href);
  const whatsappHref = footerSettings.whatsapp_number ? `https://wa.me/${footerSettings.whatsapp_number.replace(/\D/g, '')}` : '';
  return (
    <footer className="bg-gray-900 text-gray-300" role="contentinfo">
      <div className="container-main py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-6" aria-label="SIAEDTS-SARL Home">
              <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <span className="text-xl font-bold text-white">SIAEDTS-SARL</span>
            </Link>
            <p className="text-gray-400 mb-6 max-w-xs">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              {configuredSocialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-green-400 transition-colors duration-200"
                  aria-label={social.name}
                >
                  {social.icon}
                </a>
              ))}
              {whatsappHref && <a href={whatsappHref} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-green-400 transition-colors duration-200" aria-label="WhatsApp"><span className="text-sm font-bold">WA</span></a>}
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.company')}</h3>
            <ul className="space-y-2" role="list">
              {footerLinks.company.map((link) => (
                <li key={link.key}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-green-400 transition-colors duration-200"
                  >
                    {t(`footer.links.${link.key}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.products')}</h3>
            <ul className="space-y-2" role="list">
              {footerLinks.products.map((link) => (
                <li key={link.key}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-green-400 transition-colors duration-200"
                  >
                    {t(`footer.links.${link.key}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.services')}</h3>
            <ul className="space-y-2" role="list">
              {footerLinks.services.map((link) => (
                <li key={link.key}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-green-400 transition-colors duration-200"
                  >
                    {t(`footer.links.${link.key}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.resources')}</h3>
            <ul className="space-y-2" role="list">
              {footerLinks.resources.map((link) => (
                <li key={link.key}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-green-400 transition-colors duration-200"
                  >
                    {t(`footer.links.${link.key}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.legal')}</h3>
            <ul className="space-y-2" role="list">
              {footerLinks.legal.map((link) => (
                <li key={link.key}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-green-400 transition-colors duration-200"
                  >
                    {t(`footer.links.${link.key}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} SIAEDTS-SARL. {t('footer.rights')}
          </p>
          <div className="flex items-center space-x-4 text-sm text-gray-500">
            <span>{t('footer.madeWithCare')}</span>
            <span aria-hidden="true">|</span>
            <span>Développé par N'faly Kamara</span>
            <a className="hover:text-green-400 transition-colors" href="https://wa.me/224624286189" target="_blank" rel="noopener noreferrer">
              WhatsApp: +224 624 286 189
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}